import React from 'react'
import Image from 'components/image/image'
import './block-text.sass'

const getImage = (img) => (
  <div className="BlockText__content k-max-width--1">
    <Image image_url={`content/${img}`}
           className="img-fluid BlockText__image"
           alt={img} />

  </div>
)

const getMarkDown = (md) => (
  <div
    className="BlockText__content"
    dangerouslySetInnerHTML={{ __html: md }} />
)

const getContent = (contents) => {
  return contents.map((content, i) => {
    return (
      <React.Fragment key={i}>
        {
          content.substring(0, 10).indexOf('/content/') > -1
            ? getImage(content.split('/content/').pop(1))
            : getMarkDown(content)
        }
      </React.Fragment>
    )
  })
}

const BlockText = ({ data }) => {
  return (
    <section className={`
      BlockText
      ${data.classes? data.classes : ''}
    `}>
      <div className="container-fluid k-section">
        {getContent(data.content)}
      </div>
    </section>
  )
}

export default BlockText
